const defaultState = {
  access_token: "",
  user: "",
  isReconnecting: true,
  isConnected: false
};

export default defaultState;
